import { ISelectItem } from "@/types";
import { IOfferStatus, IOfferStatusRequest } from "@/types/offerStatus";

export class OfferStatus implements IOfferStatus {
  public id = 0;
  public name = "";
  public color = "";

  public constructor(props?: IOfferStatus) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(member: IOfferStatus): ISelectItem {
    return {
      text: member.name,
      value: member.id,
    };
  }
}

export class OfferStatusRequest implements IOfferStatusRequest {
  public id = 0;
  public name = "";
  public color = "";

  public constructor(props?: IOfferStatus) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}
